module.exports = __webpack_public_path__ + "static/media/MainTable_2.b6be5681.PNG";